'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { api } from '~/libs/api';
import type { FacebookEvents } from '~/services/facebook';
const useSendFacebookPageViewEvent = t0 => {
  const $ = _c(5);
  const eventName = t0 === undefined ? "ViewContent" : t0;
  const sendEvent = api.facebook.sendEvent.useMutation();
  const pathname = usePathname();
  let t1;
  if ($[0] !== eventName || $[1] !== sendEvent) {
    t1 = () => {
      sendEvent.mutate({
        eventName
      });
    };
    $[0] = eventName;
    $[1] = sendEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pathname) {
    t2 = [pathname];
    $[3] = pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
};
export default useSendFacebookPageViewEvent;